<template>
  <div>
    <Button type="primary" @click="modal1 = true">新增</Button>
    <Button type="primary" @click="selmachine" style="margin-left: 10px;">刷新</Button>
    <Select
          v-model="machineType"
          placeholder="选择机器类型"
          style="width: 200px; margin-top: 10px"
          @on-change="handleCurrencyTypeChange"
        >
          <Option value="">全部</Option>
          <Option value="0">魔鬼城</Option>
          <Option value="5">爆爆乐</Option>
          <Option value="6">金币传说</Option>
      </Select>
    <Table :columns="columns10" :data="data9"> </Table>

    <Modal
      v-model="modal1"
      title="新增机器"
      width="1000"
      :loading="loading"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="房间名称">
            <Input placeholder="请输入房间名称" v-model="roomname"></Input>
          </FormItem>
          <FormItem label="房间等级">
            <Input placeholder="请输入房间等级" v-model="roomlv"></Input>
          </FormItem>
          <FormItem label="单价">
            <Input placeholder="请输入单价" v-model="danjia"></Input>
          </FormItem>
          <FormItem label="机器类型">
            <Select v-model="machinetype">
              <Option value="0">魔鬼城</Option>
              <Option value="5">爆爆乐</Option>
              <Option value="6">金币传说</Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="几个信号给礼品">
            <Input placeholder="奖励进度" v-model="progress"></Input>
          </FormItem> -->
          <FormItem label="一票等于多少币">
            <Input placeholder="请输奖励" v-model="jiangli"></Input>
            <!-- <Button type="primary" size="small" @click="openGoodsSearchModal" style="margin-left: 5px;">查询商品</Button> -->
          </FormItem>
          <FormItem label="视频地址">
            <Input placeholder="请输入视频地址" v-model="videourl1"></Input>
          </FormItem>
          <FormItem label="备注名称">
            <Input placeholder="请输入备注名称" v-model="broomname"></Input>
          </FormItem>
          <FormItem label="排序">
            <Input placeholder="请输入排序" v-model="sort" @input="validateNumber('sort')"></Input>
          </FormItem>
          <single-upload title="上传封面图" @update:image="updateimage1" />
          <single-upload title="上传规则图" @update:image="updateimage2" />
        </Form>
      </div>
    </Modal>

    <Modal
      v-model="modal2"
      title="新增小板"
      width="1000"
      :loading="loading"
      @on-ok="okxb"
      @on-cancel="cancel"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="机器号">
            <Input placeholder="请输入机器号" v-model="xbid"></Input>
          </FormItem>
          <!-- <FormItem label="彩票币数">
            <Input placeholder="一个彩票等于多少币" v-model="piaonum"></Input>
          </FormItem> -->
          <FormItem label="小板座位,从1开始">
            <Input placeholder="请输入小板座位" v-model="xbsort"></Input>
          </FormItem>
          <FormItem label="识别小板号">
            <Input placeholder="请输入识别小板号" v-model="xbvideomachineid"></Input>
          </FormItem>
        </Form>
      </div>
    </Modal>
    <mgcGameListModal
      :visible="modal3"
      :user_id="clickmachineid"
      :roomid="clickroomid"
      @guanbimodal="guanbimodal"
    />
    <!-- 商品查询弹窗 -->
    <Modal v-model="goodsSearchModal" title="商品查询" width="800">
      <div>
        <Input
          v-model="goodsSearchName"
          placeholder="输入商品名称"
          style="width: 200px; margin-right: 10px"
        />
        <Select
          v-model="goodsSearchType"
          placeholder="请选择商品分类"
          style="width: 200px; margin-right: 10px"
        >
          <Option value="">未选择</Option>
          <Option
            v-for="item in goodstypeOptions"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Button type="primary" @click="searchProducts">查询</Button>
      </div>
      
      <Table :columns="goodsColumns" :data="goodsData">
        <template slot="footer">
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page
                :total="goodsTotal"
                :current="goodsCurrent"
                :page-size="10"
                @on-change="changeGoodsPage"
              ></Page>
            </div>
          </div>
        </template>
      </Table>
      
      <div slot="footer">
        <Button @click="closeGoodsSearchModal">取消</Button>
      </div>
    </Modal>
    <Modal
      v-model="editModal"
      title="编辑机器"
      width="1000"
      :loading="loading"
      @on-ok="updateMachine"
      @on-cancel="cancelEdit"
    >
      <div>
        <Form :label-width="120">
          <FormItem label="房间名称">
            <Input placeholder="请输入房间名称" v-model="editForm.roomname"></Input>
          </FormItem>
          <FormItem label="房间等级">
            <Input placeholder="请输入房间等级" v-model="editForm.roomlv"></Input>
          </FormItem>
          <FormItem label="单价">
            <Input placeholder="请输入单价" v-model="editForm.danjia"></Input>
          </FormItem>
          <FormItem label="机器类型">
            <Select v-model="editForm.machinetype">
              <Option value="0">魔鬼城</Option>
              <Option value="5">爆爆乐</Option>
              <Option value="6">金币传说</Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="几个信号给礼品">
            <Input placeholder="奖励进度" v-model="editForm.progress"></Input>
          </FormItem> -->
          <FormItem label="一票等于多少币">
            <Input placeholder="请输奖励" v-model="editForm.jiangli"></Input>
            <!-- <Button type="primary" size="small" @click="openGoodsSearchModal" style="margin-left: 5px;">查询商品</Button> -->
          </FormItem>
          <FormItem label="视频地址">
            <Input placeholder="请输入视频地址" v-model="editForm.videourl1"></Input>
          </FormItem>
          <FormItem label="备注名称">
            <Input placeholder="请输入备注名称" v-model="editForm.broomname"></Input>
          </FormItem>
          <FormItem label="排序">
            <Input placeholder="请输入排序" v-model="editForm.sort" @input="validateEditNumber('sort')"></Input>
          </FormItem>
          <single-upload title="上传封面图" :old-url="editForm.fengmian" @update:image="updateEditImage1" />
          <single-upload title="上传规则图" :old-url="editForm.guize" @update:image="updateEditImage2" />
        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
import SingleUpload from "@/components/Upload/singleUpload";
import expandRow from "./mgcmanage_expand.vue";
import mgcGameListModal from "./mgcGameListModal.vue"; 
import { 
  setmgcmachine,
  selmgcmachine,
  setmgcxb,
  updateMachineStatus,
  delXiaoban,
  updateMgcMachine,
} from "../../api/machine";
import { cmsSelgoods } from "../../api/product"; 

const OSS = require("ali-oss");
var ossClient = null;
export default {
  components: { expandRow, SingleUpload, mgcGameListModal },
  data() {
    return {
      goodstypeOptions: this.$goodsTypeOptions, // 商品分类选项
      machineType: "",
      piaonum: "0",
      fengmian: "", //封面图
      guize: "", //规则图
      roomlv: "", //房间等级
      duankouhao: "", //端口号
      roomname: "", //房间名称
      danjia: "", //单价
      jiangli: "", //奖励
      progress: "", //奖励进度
      videourl1: "", //视频地址1
      broomname: "", //备注名称
      sort: "0", // 排序
      loading: true,
      modal1: false,
      modal2: false,
      modal3: false,
      machinetype: 0,
      jltype: 0, //奖励类型,
      xbid: "", //小板id
      xbsort: 1, //小板座位号
      xbvideomachineid: "", //识别小板号
      clickmachineid: "",
      clickroomid: "",
      // 编辑相关数据
      editModal: false,
      editForm: {
        roomid: "", // 房间ID，用于更新时的标识
        machinetype: "0",
        fengmian: "", //封面图
        guize: "", //规则图
        roomlv: "", //房间等级
        roomname: "", //房间名称
        danjia: "", //单价
        jiangli: "", //奖励
        progress: "", //奖励进度
        videourl1: "", //视频地址1
        broomname: "", // 备注名称
        sort: "0" // 排序
      },
      columns10: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            console.log(JSON.stringify(params.row.data));
            return h(expandRow, {
              props: {
                row: params.row,
              },
              on: {
                triggerReturnOrder: (rowData) => {
                  console.log("rowData", rowData);
                  this.clickmachineid = rowData[0].machineid + "";
                  this.clickroomid = rowData[0].roomid + "";

                  console.log("====" + this.clickmachineid);
                  this.modal3 = true;
                }, // 监听 expandRow 的事件，并调用 queryGoods
                triggerDelete: (rowData) => {
                  console.log("rowData", rowData);
                 this.delXiaoban(rowData[0]);
                }, // 监听 expandRow 的事件，并调用 queryGoods
              },
            });
          },
        },
        {
          title: "房间id",
          key: "roomid",
        },
        {
          title: "房间名称",
          key: "roomname",
        },
        {
          title: "备注名称",
          key: "broomname",
        },
        {
          title: "房间等级",
          key: "roomlv",
        },

        {
          title: "单价",
          key: "price",
        },
        {
          title: "封面图",

          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: process.env.OSS + params.row.roomimg,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },

          // key: "image",
        },
        {
          title: "一票等于多少币",
          key: "reward",
        },
        // {
        //   title: "商品名",
        //   key: "goodsname",
        // },
        {
          title: "机器状态",
          key: "status",
          render: (h, params) => {
            const status = params.row.status;
            return h(
              "span",
              status === 0 ? "关机" : status === 1 ? "开机" : "维护"
            );
          },
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.openEditModal(params.row);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickmachineid = params.row.roomid;
                      this.modal2 = true;
                    },
                  },
                },
                "添加小板"
              ),
              params.row.status === 0 || params.row.status === 2
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.updateMachineStatus(1);
                        },
                      },
                    },
                    "开机"
                  )
                : null,
              params.row.status === 1 || params.row.status === 2
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.clickmachineid = params.row.roomid;
                          this.updateMachineStatus(0);
                        },
                      },
                    },
                    "关机"
                  )
                : null,
            ]);
          },
        },
      ],
      data9: [],
      // 商品查询相关数据
      goodsSearchModal: false,
      goodsSearchName: "",
      goodsSearchType: "",
      goodsData: [],
      goodsTotal: 0,
      goodsCurrent: 1,
      goodsColumns: [
        {
          title: "商品id",
          key: "id",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "封面图片",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: process.env.OSS + params.row.goodsimg,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "商品分类",
          key: "goodstype",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.selectGoods(params.row);
                    },
                  },
                },
                "选择"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.selmachine();
  },
  methods: {
    delXiaoban(data) {
      delXiaoban(data).then((res) => {
        this.selmachine();
      });
    },
    updateMachineStatus(status) {
      updateMachineStatus({
        status: status,
        roomid: this.clickmachineid,
        machineNumber: this.machineNumber,
      }).then((res) => {
        this.selmachine();
      });
    },
    selmachine() {
      console.log("===");

      selmgcmachine({
        machinetype: this.machineType
      }).then((res) => {
        console.log("===" + JSON.stringify(res));

        this.data9 = res.data;
      });
    },
    
    handleCurrencyTypeChange() {
      this.selmachine();
    },
    updateimage1(value) {
      this.fengmian = value;
      console.log("updateimage1" + value);
    },
    updateimage2(value) {
      this.guize = value;
      console.log("updateimage2" + value);
    },
    updateEditImage1(value) {
      this.editForm.fengmian = value;
      console.log("updateEditImage1" + value);
    },
    updateEditImage2(value) {
      this.editForm.guize = value;
      console.log("updateEditImage2" + value);
    },
    openEditModal(row) {
      // 填充编辑表单数据
      this.editForm = {
        roomid: row.roomid,
        machinetype: row.machinetype.toString(),
        fengmian: row.roomimg, // 保存原始图片路径
        guize: row.rule, // 保存原始规则图路径
        roomlv: row.roomlv,
        roomname: row.roomname,
        danjia: row.price,
        jiangli: row.reward,
        sort: row.sort,
        progress: row.progress ? row.progress.toString() : "",
        videourl1: row.videourl1 || "",
        broomname: row.broomname || "", // 保存备注名称
      };
      // 打开编辑模态框
      this.editModal = true;
    },
    updateMachine() {
      // 调用更新API
      updateMgcMachine({
        roomid: this.editForm.roomid,
        roomname: this.editForm.roomname,
        roomlv: this.editForm.roomlv,
        image: this.editForm.fengmian,
        rule: this.editForm.guize,
        price: this.editForm.danjia,
        reward: this.editForm.jiangli,
        machinetype: parseInt(this.editForm.machinetype),
        progress: parseInt(this.editForm.progress) || 0,
        sort: parseInt(this.editForm.sort) || 0,
        videourl1: this.editForm.videourl1,
        broomname: this.editForm.broomname,
      })
        .then((res) => {
          this.$Message.success("更新成功");
          this.editModal = false;
          // 刷新列表
          this.selmachine();
        })
        .catch((err) => {
          this.$Message.error("更新失败");
        });
    },
    cancelEdit() {
      this.editModal = false;
      this.$Message.info("取消编辑");
    },
    ok() {
      setmgcmachine({
        roomname: this.roomname,
        roomlv: this.roomlv,
        image: this.fengmian,
        rule: this.guize,
        price: this.danjia,
        reward: this.jiangli,
        machinetype: this.machinetype,
        sort: parseInt(this.sort) || 0,
        videourl1: this.videourl1,
        progress: parseInt(this.progress),
        broomname: this.broomname,
      })
        .then((res) => {
          this.modal1 = false;
          this.$Message.info("Clicked ok");
        })
        .catch((err) => {});
      //
    },
    okxb() {
      setmgcxb({
        machineid: this.xbid,
        sort: this.xbsort,
        piaonum: this.piaonum,
        roomid: this.clickmachineid,
        videomachineid: this.xbvideomachineid,
      })
        .then((res) => {
          this.modal2 = false;
          this.$Message.info("Clicked ok");
        })
        .catch((err) => {});
    },
    cancel() {
      this.$Message.info("Clicked cancel");
    },
    guanbimodal() {
      this.modal3 = false;
    },
    openGoodsSearchModal() {
      this.goodsSearchModal = true;
      this.goodsSearchName = "";
      this.goodsSearchType = "";
      this.goodsCurrent = 1;
      this.searchProducts();
    },
    closeGoodsSearchModal() {
      this.goodsSearchModal = false;
    },
    searchProducts() {
      const params = {
        goodsname: this.goodsSearchName || undefined,
        goodstype: this.goodsSearchType || undefined,
        page: this.goodsCurrent,
      };
      
      cmsSelgoods(params)
        .then((response) => {
          this.goodsData = response.data.rows;
          this.goodsTotal = response.data.pagination.total;
          this.goodsCurrent = response.data.pagination.page;
        })
        .catch((error) => {
          this.$Message.error("获取商品列表失败");
          console.error(error);
        });
    },
    changeGoodsPage(page) {
      this.goodsCurrent = page;
      this.searchProducts();
    },
    selectGoods(goods) {
      if (this.editModal) {
        this.editForm.jiangli = goods.id;
      } else {
        this.jiangli = goods.id;
      }
      this.closeGoodsSearchModal();
      this.$Message.success("已选择商品：" + goods.goodsname);
    },
    validateNumber(field) {
      if (this[field] && !/^\d*$/.test(this[field])) {
        this[field] = this[field].replace(/[^\d]/g, '');
      }
    },
    validateEditNumber(field) {
      if (this.editForm[field] && !/^\d*$/.test(this.editForm[field])) {
        this.editForm[field] = this.editForm[field].replace(/[^\d]/g, '');
      }
    },
  },
};
</script>
